export const AUTOCOMPLETE_FORM_FIELD_ID = 'rs-autocomplete-form-field';
export const AUTOCOMPLETE_ERROR_ID = 'rs-autocomplete-form-error';
export const AUTOCOMPLETE_PANEL_CLASS = 'rs-autocomplete-panel';
